import { Component, inject } from '@angular/core';
import {
  MatSnackBarAction,
  MatSnackBarActions,
  MatSnackBarLabel,
  MatSnackBarRef
} from '@angular/material/snack-bar';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-error-snackbar',
  templateUrl: 'error-snackbar.component.html',
  styles: `
    :host {
      display: flex;
      background-color: red;
    }

    .green-snackbar {
      background-color: #2ba958;
      color: #eeeeee;
    }

    .error-snackbar {
      background-color: #d32f2f;
      color: #eeeeee;
    }
    .action {
      background-color: #d32f2f;
      padding: 0 10px;
    }
  `,
  imports: [MatButtonModule, MatSnackBarLabel, MatSnackBarActions, MatSnackBarAction]
})
export class ErrorSnackbarComponent {
  snackBarRef = inject(MatSnackBarRef);
}
